import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useSelector } from 'react-redux';
import { getUser } from 'redux/selectors';
import { HelpCenterForm } from '../layout-components/Common/HelpCenterButton';

export default function RedirectComponent() {
  const ref = useRef(null);
  const location = useLocation();
  const history = useHistory();
  const user = useSelector(getUser);

  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);

  useEffect(() => {
    const isPublicPage = location.pathname.startsWith('/user');
    if (params.get('return_to') && user.authenticated && !isPublicPage) {
      (async () => {
        const fetchedCreds = await ref.current?.triggerFetch();
        if (fetchedCreds) {
          ref.current?.triggerSubmit();
        } else {
          history.push('/');
        }
      })();
    }

  }, [params, location.pathname, user, history])



  return (
    <>
      <HelpCenterForm ref={ref} target='_self' return_to={params.get('return_to') ?? undefined} />
    </>
  );
}
